import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const CountryRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--country']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
